import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useUserData } from "src/context/userContext";
import {
  asiakas_asiakasLinks_add,
  asiakas_asiakasLinks_save,
} from "src/data/asiakas/AsiakasFunctions";
import GridKeikkaEditor_SourceAsiakasSettings_TableRow from "./GridKeikkaEditor_SourceAsiakasSettings_TableRow";
import { AddIcon, CancelIcon, SaveIcon } from "src/components/icons/ActionIcons";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import PropTypes from "prop-types";
import MySkeleton from "src/components/layout/MySkeleton";
import MyDivider from "src/components/layout/MyDivider";
import AsiakasSelectorAutocompleteModal from "src/components/asiakas/list/AsiakasSelectorAutocompleteModal";
import EditTarjousModal from "src/components/tarjous/EditTarjous/EditTarjousModal";

export default function GridKeikkaEditor_SourceAsiakasSettings({ onClose }) {
  const { token, userAsiakas } = useUserData();
  const { sourceAsiakasSettings, isLoaded, reload } = useContext(GridKeikka_NewKeikkaContext);
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addNewAsiakas_isOpen, addNewAsiakas_setIsOpen] = useState(false);
  const [selectedTarjousId, setSelectedTarjousId] = useState(0);

  useEffect(() => {
    const asynk = async () => {
      setIsLoadedState(true);
    };
    asynk();
  }, []);

  const handleSaveClick = async () => {
    setIsLoading(true);
    for (const item of sourceAsiakasSettings) {
      await asiakas_asiakasLinks_save(
        item.asiakasAsiakasLinkId,
        item.asiakasId,
        item.linkedAsiakasId,
        item.asiakasAsiakasLinkTypeId,
        item.asiakasAsiakasLinkJSON,
        item.comment,
        item.tarjousId,
        token
      );
    }
    setIsLoading(false);
  };

  const handleAddNewAsiakasClick = () => addNewAsiakas_setIsOpen(true);

  const handleAddNewAsiakasSelected = async (asiakas) => {
    const asiakasId = userAsiakas.asiakasId;
    const linkedAsiakasId = asiakas.asiakasId;
    await asiakas_asiakasLinks_add(asiakasId, linkedAsiakasId, 1, token);
    reload();
    addNewAsiakas_setIsOpen(false);
  };
  console.log("sourceAsiakasSettings", sourceAsiakasSettings);
  const handleEditTarjousClick = (tarjousId) => setSelectedTarjousId(tarjousId);

  return (
    <>
      <AsiakasSelectorAutocompleteModal
        isOpen={addNewAsiakas_isOpen}
        setIsOpen={addNewAsiakas_setIsOpen}
        onSelect={handleAddNewAsiakasSelected}
        source="source"
        title="Lähdeasiakas"
        label="Valitse tilauksen vastaanottanut asiakas"
        helpId={"grid_keikka_source_asiakas"}
      />
      <EditTarjousModal
        tarjousId={selectedTarjousId}
        isOpen={selectedTarjousId > 0}
        setIsOpen={(isOpen) => setSelectedTarjousId(isOpen ? selectedTarjousId : 0)}
      />
      <TableContainer component={Paper}>
        <Table size="small" style={{ fontSize: "0.8em" }}>
          <TableHead>
            <TableRow>
              <TableCell>Lähdeasiakas</TableCell>
              <TableCell>Oletus toimittajat</TableCell>
              <TableCell>Laskutus</TableCell>
              <TableCell style={{ opacity: 0.7 }}>Vanha laskutus, ei käytössä</TableCell>
              <TableCell>Poista</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoaded || !isLoadedState ? (
              <TableRow className="harmaaTausta3">
                <TableCell colSpan={80}>
                  <MySkeleton height={40} />
                  <MySkeleton height={60} />
                  <MySkeleton height={60} />
                  <MySkeleton height={40} />
                </TableCell>
              </TableRow>
            ) : (
              sourceAsiakasSettings.map((item, i) => (
                <GridKeikkaEditor_SourceAsiakasSettings_TableRow
                  key={i}
                  asiakasId={item.linkedAsiakasId}
                  JSONData={item.asiakasAsiakasLinkJSON}
                  asiakasAsiakasLinkId={item.asiakasAsiakasLinkId}
                  evenRowNum={i % 2 === 0}
                  onEditTarjousClick={handleEditTarjousClick}
                  onSaveTarjousClick={handleSaveClick}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <MyDivider />
      <div className="spaceBetween">
        <Button variant="outlined" color="primary" onClick={handleAddNewAsiakasClick}>
          <AddIcon /> Lisää uusi asiakas
        </Button>
        <div style={{ display: "flex", gap: 10 }}>
          <Button variant="outlined" color="primary" onClick={onClose}>
            <CancelIcon /> Peruuta
          </Button>
          <Button
            disabled={isLoading || !isLoaded}
            variant="outlined"
            color="primary"
            onClick={handleSaveClick}>
            {isLoading ? <ProgressCirc /> : <SaveIcon />}
            Tallenna
          </Button>
        </div>
      </div>
    </>
  );
}

GridKeikkaEditor_SourceAsiakasSettings.propTypes = {
  onClose: PropTypes.func,
};
